import { useSyncExternalStore } from 'react';
import { enableAndTest, setSoundEnabled, soundState, subscribeSound } from '../lib/alertSound';
import { Button } from './ui';

function SpeakerIcon({ muted }: { muted: boolean }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className="h-5 w-5"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M11 5 6 9H3v6h3l5 4V5z" />
      {muted ? (
        <path d="m17 9 5 6m0-6-5 6" />
      ) : (
        <path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13" />
      )}
    </svg>
  );
}

// PS5 alerts are spoken on this device. Phones and tablets need one tap before
// they may make a sound at all, so until then the button asks for it; once on,
// tapping mutes this device only. Turning it back on plays a test.
export function SoundToggle() {
  const state = useSyncExternalStore(subscribeSound, soundState);

  if (state === 'on') {
    return (
      <Button
        variant="ghost"
        className="px-2.5 text-emerald-300"
        title="PS5 alerts sound on this device. Tap to mute."
        aria-label="Sound alerts on. Tap to mute this device."
        onClick={() => setSoundEnabled(false)}
      >
        <SpeakerIcon muted={false} />
      </Button>
    );
  }

  return (
    <Button
      variant="secondary"
      className={`px-2.5 ${
        state === 'locked' ? 'animate-pulse bg-amber-500/20 text-amber-200' : 'text-amber-300'
      }`}
      title={
        state === 'locked'
          ? 'Tap so this device can ring for PS5 alerts.'
          : 'PS5 alerts are muted on this device. Tap to turn sound on.'
      }
      onClick={enableAndTest}
    >
      <SpeakerIcon muted />
      <span className="hidden text-xs sm:inline">
        {state === 'locked' ? 'Tap for sound' : 'Sound off'}
      </span>
    </Button>
  );
}
